'use client';

import { ReactNode } from 'react';
import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

type ToastType = 'error' | 'success' | 'blank' | 'custom' | 'loading';

const color = (type: ToastType) =>
  classnames({
    flex: true,
    'rounded-tl-lg': true,
    'rounded-bl-lg': true,
    'p-2': true,
    'bg-toast-icon-background-color': true,
    'self-stretch': true,
    'items-center': true,
    'text-toast-icon-error-color': type === 'error',
    'text-toast-icon-success-color': type === 'success',
    'text-toast-icon-notice-color': type !== 'error' && type !== 'success',
  });

const buttonClassName = classnames(
  'border-0',
  'bg-toast-background-color',
  'text-xs',
  'justify-end',
  'text-toast-dismiss-color',
  'm-1'
);

interface Props {
  children: ReactNode;
  dismiss: () => void;
  icon?: Icon;
  message: ReactNode;
  type: ToastType;
}

const Toast = ({ children, dismiss, icon, message, type }: Props) => (
  <div className={'flex flex-row flex-1 items-center'}>
    <div className={color(type)} data-testid={`toast-${type}`}>
      <IconView icon={icon} size="lg" />
    </div>
    <div className="flex flex-col flex-1">
      <div className="pt-4">{message}</div>
      <div className="flex flex-1 justify-end">
        <button
          data-testid={`toast-button-${type}`}
          className={buttonClassName}
          onClick={dismiss}
        >
          {children}
        </button>
      </div>
    </div>
  </div>
);

export default Toast;
